module.exports = "/_next/static/media/default-avatar-1.7f49c5da.jpg";